import { Component, OnChanges, Input } from "@angular/core";

import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";
import { ChartingService } from "src/app/charting.service";

@Component({
	selector: "app-tach-detail",
	templateUrl: "./tach-detail.component.html",
	styleUrls: ["./tach-detail.component.scss"]
})
export class TachDetailComponent implements OnChanges {
	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	component: AssemblyConfig.Tach;
	@Input()
	raw: APIResults.RawSinglesResult;

	public tsoptions?: Highcharts.Options;
	public spectrumoptions?: Highcharts.Options;
	public errormessage: string;

	constructor(private api: ApiService, private charting: ChartingService) { }

	async ngOnChanges() {
		if (this.asset && this.component && this.raw) {
			this.tsoptions = undefined;
			this.spectrumoptions = undefined;
			this.errormessage = undefined;
			try {
				const result = await this.api.GetTachVibe(this.asset.asset_id, this.component.id, this.raw.rawid)
				this.tsoptions = this.charting.RevolutionDefaults("Time Sync Avg", result.tsastats, result.meanrpm, result.tsa, "RPM");
				this.spectrumoptions = this.charting.SpectrumDefaults("Spectrum", "Gs", [
					{ type: "line", name: "Spectrum", data: result.fft },
				], false);
			} catch (err) {
				this.errormessage = "Unable to load tach details";
				console.error("Couldn't load tach vibe");
				console.log(err);
			}
		}
	}
}
